import type { Calendar } from "@app/core";
import { create } from "zustand";

/** What the user picks when importing .ics: drop everything into an existing
 *  calendar, or create a fresh one. */
export type IcsImportTarget =
  | { kind: "cancel" }
  | { kind: "existing"; calendarId: string }
  | { kind: "new"; name: string };

export interface IcsImportAsk {
  /** How many items the picked file(s) contain. */
  count: number;
  /** How many files were picked. */
  fileCount: number;
  /** Suggested new-calendar name (from X-WR-CALNAME or a date fallback). */
  suggestedName: string;
  /** Existing calendars to choose from. */
  calendars: Calendar[];
}

interface State {
  open: boolean;
  pending: IcsImportAsk | null;
  resolveFn: ((t: IcsImportTarget) => void) | null;
  ask: (pending: IcsImportAsk) => Promise<IcsImportTarget>;
  resolve: (t: IcsImportTarget) => void;
}

export const useIcsImportStore = create<State>((set, get) => ({
  open: false,
  pending: null,
  resolveFn: null,
  ask: (pending) =>
    new Promise((resolve) => {
      set({ open: true, pending, resolveFn: resolve });
    }),
  resolve: (t) => {
    const fn = get().resolveFn;
    set({ open: false, pending: null, resolveFn: null });
    fn?.(t);
  },
}));
